import React from 'react';
import { Link } from 'react-router-dom'
import Services from "../../api/Services";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const ServiceSectionS4 = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid">
                <div className="service-wrap">
                    <div className="row">
                        {Services.slice(4, 8).map((service, item) => (
                            <div className="col-lg-3 col-md-6 col-12 fade_bottom" key={item}>
                                <div className="service-card">
                                    <div className="content">
                                        <div className="icon">
                                            <img src={service.Icon} alt="icon" />
                                        </div>
                                        <h2><Link onClick={ClickHandler} to={`/service-single/${service.slug}`}>{service.title}</Link></h2>
                                        <p>{service.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSectionS4;